import { useEffect } from 'react';

type Props = {
  shouldLoad: boolean;
};

export default function ThirdPartyScripts({ shouldLoad }: Props) {
  // Ensure Chameleon stub exists synchronously so calls like chmln.identify() don't throw
  try {
    const w = window as any;
    const c = 'chmln';
    if (!w[c]) w[c] = {};
    const methods = 'identify alias track clear set show on off custom help _data'.split(' ');

    for (let i = 0; i < methods.length; i++) {
      const name = methods[i];
      const queueName = name + '_a';
      if (!w[c][queueName]) w[c][queueName] = [];

      if (typeof w[c][name] !== 'function') {
        w[c][name] = function (...args: any[]) {
          w[c][queueName].push(args);
        };
      }
    }
  } catch {
    // no-op
  }

  useEffect(() => {
    if (!shouldLoad) return;

    // Chameleon loader
    try {
      const w = window as any;
      const d = document;
      const token = 'SoR7iSTKYtGrupGnBpk3dZFDzsZUmmhjrlPdakdGZUMoq9-1LSOFV-CX79xgwVNSfw9gQH';
      const key = 'chmln';
      if (!w[key]) w[key] = {};

      if (!d.getElementById('chmln-loader')) {
        w[key].accountToken = token;
        w[key].location = w.location.href.toString();
        w[key].now = new Date();
        const script = d.createElement('script');
        script.id = 'chmln-loader';
        script.async = true;
        script.src = `https://fast.trychameleon.com/messo/${token}/messo.min.js`;
        d.head.appendChild(script);
      }
    } catch {
      console.error('Failed to load chameleon loader');
    }

    // Churnkey loader
    try {
      const w = window as any;

      if (!w.churnkey || !w.churnkey.created) {
        w.churnkey = { created: true };

        if (!document.getElementById('churnkey-script')) {
          const a = document.createElement('script');
          a.id = 'churnkey-script';
          a.src = 'https://assets.churnkey.co/js/app.js?appId=c39usm135';
          a.async = true;
          document.head.appendChild(a);
        }
      }
    } catch {
      console.error('Failed to load churnkey loader');
    }
  }, [shouldLoad]);

  return null;
}
